import { NBase } from './interface';

export const baseReducer: NBase.Reducer = {
    openedMenu: null
}